<div *ngIf="loading">
    <div class="loader is-active padding-leader-3 padding-trailer-3">
        <div class="loader-bars"></div>
        <div class="loader-text">Loading Share Component...</div>
    </div>
</div>

<div *ngIf="!loading">
    <div class="searchUsers flow">
        <div *ngIf="alreadySharedNames.length > 0" class="field right">This Layer is already shared with: {{ alreadySharedNames }}</div>
        <div class="shareLabel">To:</div>
        <div class="field right">
            <input type="text" placeholder="Search by email address" [(ngModel)]="inputSearchText" (ngModelChange)="outputSearchText.next(inputSearchText)">
            <div class="returnedUserList" *ngIf="mapcoreUsers[0]">
                <div *ngFor="let user of mapcoreUsers; let i = index" (click)="selectUser(i)">{{ user.email }}</div>
            </div>
        </div>
    </div>
    <hr>
    <div class="flow">
        <div class="shareLabel">Recipients:&nbsp;</div>
        <div *ngIf="recipients[0]" class="recipientList field right">
            <table cellspacing="0">
                <tr *ngFor="let recip of recipients; let i = index">
                    <td>{{ recip.firstName }}&nbsp;{{ recip.lastName }}:</td>
                    <td>{{ recip.email }}</td>
                    <td><i class="icon-ui-close-circled remove" (click)="removeRecipient(i)"></i></td>
                </tr>
            </table>
        </div>
        <p class="field right" *ngIf="!recipients[0]">None</p>
    </div>
    <hr>
    <div class="flow" *ngIf="includeEmail">
        <div class="shareLabel">Message:</div>
        <textarea class="field right" rows="5" placeholder="Email message here" [(ngModel)]="emailText"></textarea>
    </div>
    <hr *ngIf="includeEmail">
    <div class="buttons flow">
        <div class="status left">
            <div *ngIf="sharingLayer">
                <span class="k-i-loading"></span>
                <div class="shareMessage">Sharing Layer...</div>
            </div>
            <div *ngIf="successMessage" class="center">
                <i class="icon-ui-check-mark">Layer successfully shared</i>
            </div>
            <div *ngIf="failureMessage" class="center">
                <i class="icon-ui-close icon-ui-red">You must own a layer to share, please save a copy before sharing. Please try again.</i>
            </div>
        </div>
        <button class="btn right shareButton" (click)="shareLayer()" [disabled]="!recipients[0] || (includeEmail && emailText.length === 0)">
            Share
        </button>
        <button class="btn btn-clear right cancelButton" (click)="resetAndClose()">Cancel</button>
    </div>
</div>
